/*
 * @Author: Chris 
 * @Date: 2022-09-26 15:17:08 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-09-26 16:17:53
 * @msg 双击table复制单元格的内容
 */

import Vue from "vue";

Vue.prototype.$dblClickCopy = (row, column, cell, event) => {

    let msg = row[column.property];

    // 如果是空值 则无需复制
    if (!msg) {
        return;
    }

    var save = function (e) {
        e.clipboardData.setData("text/plain", msg);
        e.preventDefault();
    };
    document.addEventListener("copy", save);
    document.execCommand("copy");
    document.removeEventListener("copy", save);
    Vue.prototype.$notify.success({
        title: '复制成功：',
        message: msg
    })
}